let CryptoJS = require("crypto-js");

export default class Storage {

    static set(key, value) {
        let data = typeof value === "object" ? JSON.stringify(value) : value;

        //console.log(key, data);

        let secureData = CryptoJS.AES.encrypt(data, '_E1@V*]Laolf:JzKU/nq7L5)b|A!j0L|{]S?:EL}0EJ8)e#&D?_$BH}2FSO>_o#');

        localStorage.setItem(key, secureData);
    };

    static del(key) {
        if(this.get(key, true) !== null){
            localStorage.removeItem(key);
        }
    };

    static get(key, retNull) {
        const secureData = localStorage.getItem(key);

        if(secureData === null || typeof secureData === "undefined"){
            return retNull ? null : false;
        }

        let decryptedData = "";
        let data = "";

        try {
            decryptedData = CryptoJS.AES.decrypt(secureData.toString(), "_E1@V*]Laolf:JzKU/nq7L5)b|A!j0L|{]S?:EL}0EJ8)e#&D?_$BH}2FSO>_o#");
            data = decryptedData.toString(CryptoJS.enc.Utf8);
        } catch (err) {
            return retNull ? null : false;
        }

        try {
            return JSON.parse(data);
        } catch (error) {
            return data;
        }
    };

    static append(key, data) {
        const oldData = this.get(key);
        this.set(key, Object.assign(typeof oldData === "object" ? oldData : {}, data));
    }

    static storeHasKey(cache_key, key){
        const cache = this.get(cache_key);
        return cache !== false && typeof cache[key] !== "undefined";
    }
}


// WEBPACK FOOTER //
// ./src/modules/base/Storage.js